import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function Solution() {
  return <section className="py-20 px-4 bg-brand-cream" data-id="element-196">
      <div className="max-w-4xl mx-auto text-center" data-id="element-197">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-198">
          <h2 className="text-3xl md:text-5xl font-extrabold text-brand-navy mb-6" data-id="element-199">
            Por eso creamos el{' '}
            <span className="text-brand-orange block mt-2" data-id="element-200">
              Pack Recetas Caseras Saludables para Perros.
            </span>
          </h2>
          <p className="text-xl md:text-2xl text-gray-700 font-medium mb-12 max-w-3xl mx-auto" data-id="element-201">
            Una guía digital práctica con recetas simples, ingredientes seguros
            y 5 herramientas para organizar, revisar y cocinar con más
            confianza.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 text-left" data-id="element-202">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-white p-8 rounded-3xl shadow-soft border border-gray-100" data-id="element-203">
            <h3 className="text-xl font-bold text-red-500 mb-6 flex items-center gap-2" data-id="element-204">
              <span className="bg-red-100 p-1 rounded-full text-red-500" data-id="element-205">
                ✕
              </span>{' '}
              Lo que NO es
            </h3>
            <ul className="space-y-4 text-gray-600" data-id="element-206">
              <li className="flex items-start gap-3" data-id="element-207">
                <span className="mt-1 text-red-400" data-id="element-208">•</span>
                No es un libro de nutrición veterinaria complejo.
              </li>
              <li className="flex items-start gap-3" data-id="element-209">
                <span className="mt-1 text-red-400" data-id="element-210">•</span>
                No es una dieta médica difícil de seguir.
              </li>
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="bg-brand-green/10 p-8 rounded-3xl shadow-soft border border-brand-green/20" data-id="element-211">
            <h3 className="text-xl font-bold text-brand-green mb-6 flex items-center gap-2" data-id="element-212">
              <CheckCircle2 className="w-6 h-6" data-id="element-213" /> Lo que SÍ es
            </h3>
            <ul className="space-y-4 text-gray-700" data-id="element-214">
              <li className="flex items-start gap-3" data-id="element-215">
                <CheckCircle2 className="w-5 h-5 text-brand-green shrink-0 mt-0.5" data-id="element-216" />
                Es una guía práctica y visual para dueños de perros que quieren
                empezar a preparar recetas caseras de forma más segura, más
                organizada y sin complicarse.
              </li>
              <li className="flex items-start gap-3" data-id="element-217">
                <CheckCircle2 className="w-5 h-5 text-brand-green shrink-0 mt-0.5" data-id="element-218" />
                Con ingredientes simples que probablemente ya tienes en casa.
              </li>
              <li className="flex items-start gap-3" data-id="element-219">
                <CheckCircle2 className="w-5 h-5 text-brand-green shrink-0 mt-0.5" data-id="element-220" />
                Y con herramientas imprimibles que puedes usar desde hoy mismo.
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}